import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logoSmall from "../assets/logo_orange.svg";

const REDIRECT_DELAY_MS = 4000;

export function EmailVerificationResult() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const verificationState = useMemo(() => {
    const raw = new URLSearchParams(location.search).get("verification") || "invalid";
    return ["verified", "already_verified", "invalid"].includes(raw) ? raw : "invalid";
  }, [location.search]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      navigate("/login", { replace: true });
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [navigate]);

  const isSuccess = verificationState !== "invalid";
  const titleKey = `emailVerification.${verificationState}.title`;
  const bodyKey = `emailVerification.${verificationState}.body`;

  return (
    <div className="login-screen">
      <div className="login-brand">
        <img alt={t("login.logoAlt")} className="login-logo" src={logoSmall} />
        <h1>{t("app.title")}</h1>
        <p className="login-tagline">{t("app.tagline")}</p>
      </div>

      <div className="login-card">
        <div className="login-card__header">
          <h2 className="login-title">{t(titleKey)}</h2>
          <p className="login-subtitle">{t(bodyKey)}</p>
        </div>

        <div className={`login-status ${isSuccess ? "login-status--success" : "login-status--error"}`}>
          <strong>{t(titleKey)}</strong>
          <p>{t("emailVerification.redirecting")}</p>
        </div>

        <div className="login-links">
          <a href="/login" className="login-link-primary">{t("login.backToLogin")}</a>
        </div>
      </div>
    </div>
  );
}
